<template>
  <div class="CiteScore" v-if="tableData && tableData.length">
    <div
      class="CiteScore_box mb-20"
      v-for="(item, index) in groupedData"
      :key="index"
    >
      <div class="CiteScore_box_left">
        <div>
          <p class="CiteScore_box_left_title">
            中国科学院SCI期刊分区
          </p>
          <p v-if="item[0].version">
            ( <span>{{ item[0].version }}</span> )
          </p>
        </div>
      </div>
      <div class="CiteScore_box_right">
        <!-- JIF分区表格 -->
        <el-table class="CiteScore_box_right_table mb-20" border :data="item">
          <el-table-column label="大类学科" width="100" align="center">
            <template slot-scope="scope">
              <div class="CiteScore_box_right_table_flex">
                <span>{{ scope.row.subjectCategory }}</span>
                <div class="tag">{{ scope.row.subjectCategoryPartition }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="小类学科" width="200" align="center">
            <template slot-scope="scope">
              <div class="CiteScore_box_right_table_flex">
                <div>
                  <div>{{ scope.row.subjectSubCategoryEn }}</div>
                  <div>{{ scope.row.subjectSubCategory }}</div>
                </div>
                <div class="tag">
                  {{ scope.row.subjectSubCategoryPartition }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Top期刊" width="50" align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                {{ scope.row.topJournal ? "是" : "否" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="综述期刊" width="50" align="center">
            <template slot-scope="scope">
              <div style="text-align: center;">
                {{ scope.row.reviewJournal ? "是" : "否" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="CiteScore_box mb-20">
      <div class="CiteScore_box_left">
        <div>
          <p class="CiteScore_box_left_title">
            中国科学院《国际期刊预警名单(试行)》名单
          </p>
        </div>
      </div>
      <div class="CiteScore_box_right">
        <p v-html="journalAlert"></p>
      </div>
    </div>

    <ul class="CiteScore_ul">
      <li>
        <p><span>CiteScore：</span>是爱思唯尔（Elsevier）基于 Scopus 数据库，通过计算期刊近 4 年发表的所有文献（含研究论文、综述等）的被引总数除以同期发表的文献总量，来衡量期刊学术影响力的指标。</p>
        <p><span>SJR：</span>（Scimago Journal Rank）是一种衡量期刊声望和影响力的指标，它根据期刊所获引用次数及引用期刊的声望来计算，体现期刊过去3年发表论文的加权引用平均次数。</p>
        <p><span>SNIP：</span>（Source Normalized Impact per Paper）是基于学科领域引用特征的标准化影响系数，通过期刊平均引用次数除以其主题领域的 “引用潜力” 得出，用于不同领域期刊影响力的比较。</p>
      </li>
      <li>
        <p><span>JCR 分区：</span>是科睿唯安（Clarivate）基于期刊影响因子（JIF）等指标，将 Web of Science 收录的期刊按小类学科划分为 Q1 到 Q4 四个区的学术评价体系。Q1区代表学科分类中影响因子排名前25%的期刊，Q2区为前25%-50%期刊，Q3区为前50%-75%期刊，Q4区为75%以后期刊。JCR没有设置大类，只将期刊分为176个具体学科，也就是中科院分区中的小类学科。</p>
        <p><span>JIF：</span>（Journal Impact Factor，期刊影响因子）是科睿唯安（Clarivate）发布的衡量期刊近2年平均被引频次的指标，计算方式为前2年期刊发表的论文在第3年获得的总引用数除以同期可引文献数量。</p>
        <p><span>JCI：</span>（Journal Citation Indicator，期刊引证指标）是基于近3年引文数据，通过期刊被引频次与所属学科全球期刊被引表现的相对比值，来评估期刊影响力的标准化指标。</p>
      </li>
      <li>
        <P><span>中科院分区：</span>是中国科学院文献情报中心基于 Web of Science 数据库，按大类和小类学科，根据期刊学术影响力（如影响因子、被引频次等）将期刊划分为四个区的期刊评价体系。影响因子5%为1区，6%-20%为2区，21%-50%为3区，其余为4区。</P>
      </li>
    </ul>
    <!-- journalAlert -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GetcasRank } from "@/api/analysis";
export default {
  name: "CiteScore",
  props: {
    journalAlert: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters({
      magId: "magId"
    }),
    groupedData() {
      // 使用 reduce() 来根据 version 对数据进行分组
      return this.tableData.reduce((acc, curr) => {
        const versionGroup = acc.find(
          group => group[0].version === curr.version
        );
        if (versionGroup) {
          versionGroup.push(curr);
        } else {
          acc.push([curr]);
        }
        return acc;
      }, []);
    }
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.GetcasRank();
  },
  methods: {
    GetcasRank() {
      let params = {
        magId: this.magId
      };
      GetcasRank(params).then(res => {
        if (res && res.data && res.data.status === 0) {
          this.tableData = res.data.data;
          console.log(this.tableData, "tableData");
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.CiteScore {
  text-align: left;
  &_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #e2e2e2;
    &_left {
      padding: 0 20px;
      min-width: 15%;
      max-width: 15%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &_title {
        display: flex;
        align-items: center;
        i {
          color: #ffabaa;
          font-size: 20px;
          cursor: pointer;
          margin-left: 5px;
        }
      }
      p {
        font-size: 14px;
        color: #333;
        margin-bottom: 5px;
        font-weight: bolder;
        span {
          color: red;
        }
      }
    }
    &_right {
      padding: 20px;
      border-left: 1px solid #e2e2e2;
      overflow: hidden;
      flex: 1;
      &_wosLevel {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
      }
      &_table {
        width: 100%;
        color: #666;
        /deep/ th.el-table__cell {
          background: #f6f6f6 !important;
        }
        &_flex {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
        }
        /deep/ td.el-table__cell div {
          text-align: left;
        }
      }
      .editLink {
        color: #2e9aff;
        cursor: pointer;
      }
    }
    .tag {
      background: #ffeeee;
      border: 1px solid #ffb1b1;
      white-space: nowrap;
      color: #60609b;
      font-size: 12px;
      padding: 0 5px;
    }
  }
  &_ul {
    li {
      padding: 20px 15px;
      background: #F9F9F9;
      color: #666;
      margin-bottom: 10px;
      line-height: 30px;
      span {
        font-weight: bolder;
      }
    }
  }
}
</style>
